import React from "react";

const PlusIcon = ({ width, height }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 23 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.95264 12.0781H17.2475"
      stroke="#42464C"
      strokeWidth="1.41186"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6001 17.7246V6.42969"
      stroke="#42464C"
      strokeWidth="1.41186"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default PlusIcon;
